import {
  KnowledgeCardConfig,
  KnowledgeChunk,
  KnowledgeScope,
  RenderedRow
} from '~/utils/knowledge/types'

// Resolve config fns here so only serializable data crosses the prop boundary (Vue 2 SSR-safe).
export function renderChunk(config: KnowledgeCardConfig, chunk: KnowledgeChunk): RenderedRow {
  return {
    id: chunk.id,
    primary: config.primary?.(chunk) ?? '',
    title: config.title(chunk) ?? '',
    body: config.body?.(chunk) ?? '',
    promotedToOwner: chunk.scope === KnowledgeScope.Owner,
    originRepoMissing: chunk.scope === KnowledgeScope.Owner && chunk.repository == null,
    meta: config.meta
      .map((item) => {
        const icon = typeof item.icon === 'function' ? item.icon(chunk) : item.icon
        const mono = typeof item.mono === 'function' ? item.mono(chunk) : item.mono
        return {
          icon,
          mono,
          text: item.value(chunk),
          href: item.href?.(chunk)
        }
      })
      .filter((item) => item.text !== ''),
    group: config.groupBy?.(chunk) ?? ''
  }
}
